import React, { useEffect, useState } from "react";
import { updateUser, uploadImage } from "../../../api/axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ownerImg from "../../../assets/ownerImg.png";
import cameraIcon from "../../../assets/camera.svg";
import styles from "./Card.module.scss";
import Spinner from "../../../shared/Spinner/Spinner";

const Card = () => {
  const formData = new FormData();
  const user = localStorage.getItem("user");

  const [loading, setLoading] = useState(false);

  // input states
  const [img, setImg] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");

  // set fields
  // useEffect(() => {
  //   if (user) {
  //     const parsed = JSON.parse(user);
  //     setPhone(parsed.mobile);
  //   }
  // }, [user]);

  // handle image upload
  const onImageUpload = async (e) => {
    formData.append("file", e.target.files[0]);
    formData.append("upload_preset", "o959yirs");

    const response = await uploadImage(formData);
    if (response.status === 200) {
      setImg(response.data.url);
    } else {
      setImg("error");
    }
  };

  // handleSubmit
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   if (phone || password || img) {
  //     setLoading(true);
  //     const parsed = JSON.parse(user);

  //     const payload = {
  //       userId: parsed._id,
  //       mobile: phone,
  //       userNewPassword: password,
  //       profilepic: img,
  //     };

  //     const response = await updateUser(payload);
  //     setLoading(false);
  //     if (response.status === 200) {
  //       toast.success("Profile Updated Successfully!");
  //     } else {
  //       toast.error(response.data.message);
  //     }
  //   }
  // };

  return (
    <div className={styles.container}>
      <form 
      // onSubmit={handleSubmit}
      >
        <div className={styles.upload}>
          {img && <img src={img} alt="preview" className={styles.preview} />}
          {!img && (
            <div className={styles.imgContainer}>
              <img
                src={user ? JSON.parse(user).profilepic : ownerImg}
                alt={user && JSON.parse(user).userName}
                className={styles.owner}
              />
              <img src={cameraIcon} alt="upload" className={styles.camera} />
              <input type="file" name="file" onChange={onImageUpload} />
            </div>
          )}

          <h5>{user && JSON.parse(user).userName}</h5>
        </div>

        <div className={styles.field}>
          <label>Phone Number</label>
          <input
            type="number"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
          />
        </div>

        <div className={styles.field}>
          <label>Password</label>
          <input
            type="text"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        <button type="button">{loading ? <Spinner /> : "Save Changes"}</button>
      </form>
    </div>
  );
};

export default Card;
